import { toastNotificationsSlice } from 'src/redesign/features/Toast/store/reducer';

export const showNotification = toastNotificationsSlice.actions.showNotification;
export const clearNotification = toastNotificationsSlice.actions.clearNotification;
